import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaBars, FaTimes } from 'react-icons/fa';
import './Navbar.css';

const Navbar = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { key: 'home', path: '/', label: t('nav.home') },
    { key: 'about', path: '/about', label: t('nav.about') },
    { key: 'solutions', path: '/solutions', label: t('nav.solutions') },
    { key: 'portfolio', path: '/portfolio', label: t('nav.portfolio') },
    { key: 'resources', path: '/resources', label: t('nav.resources') },
    { key: 'contact', path: '/contact', label: t('nav.contact') }
  ];

  const handleMenuClose = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="nav-container">
        <Link to="/" className="nav-logo">
          <img
            src="/assets/images/Opteam_Logo_Horizontal_Transparent.png"
            alt="Opteam Services"
            className="logo-image"
          />
        </Link>
        
        <div className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
          {navItems.map((item) => (
            <Link
              key={item.key}
              to={item.path}
              className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
              onClick={handleMenuClose}
            >
              {item.label}
            </Link>
          ))}
        </div>

        <div 
          className="nav-toggle" 
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {isMenuOpen ? <FaTimes /> : <FaBars />}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;